import React from 'react'
import { useMatch } from 'react-router-dom'
import ModelerWrapper from './ModelerWrapper'
import FolderWrapper from './FolderWrapper'
import Layout from '../components/layout/Layout'
import SideMenu from '../components/layout/SideMenu'
import TopNav from '../components/layout/TopNav'

const ProjectContentRouter = () => {
  const match = useMatch('/:org/:project/*')
  const rest = match?.params['*'] || ''
  const segments = rest.split('/')

  if (segments.includes('modeler')) {
    return (
      <Layout topNavComponent={<TopNav />}>
        <ModelerWrapper />
      </Layout>
    )
  }

  return (
    <Layout topNavComponent={<TopNav />} sideMenuComponent={<SideMenu />}>
      <FolderWrapper />
    </Layout>
  )
}

export default ProjectContentRouter
